/* Filterleiste: Desktop-Dropdowns und mobile Schublade mit Drill-down.
   Progressive Enhancement - ohne JS bleibt das Formular über den
   "Produkte anzeigen"-Knopf bedienbar. */
(function () {
  var form = document.querySelector('[data-gb-filters]');
  if (!form) return;

  var panel  = form.querySelector('[data-gb-filter-panel]');
  var scrim  = form.querySelector('[data-gb-filter-close].gb-ftr__scrim');
  var title  = form.querySelector('[data-gb-filter-title]');
  var back   = form.querySelector('[data-gb-filter-back]');
  var opener = form.querySelector('[data-gb-filter-open]');
  var groups = Array.prototype.slice.call(form.querySelectorAll('[data-gb-filter-group]'));

  var mobile = window.matchMedia('(max-width: 749px)');
  var isMobile = function () { return mobile.matches; };

  /* ── Schublade ─────────────────────────────────────── */
  function openDrawer() {
    if (!panel) return;
    panel.classList.add('is-open');
    if (scrim) scrim.hidden = false;
    document.body.classList.add('gb-ftr-locked');
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('gb-ftr-locked');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    collapseAll();
  }

  function collapseAll() {
    groups.forEach(function (g) { g.open = false; });
    syncDrill();
  }

  /* Titel und Zurück-Knopf spiegeln, in welcher Ebene man steht */
  function syncDrill() {
    if (!panel) return;
    var open = groups.filter(function (g) { return g.open; })[0];
    panel.classList.toggle('is-drilled', !!open);
    if (title) title.textContent = open ? (open.getAttribute('data-label') || 'Filter') : 'Filter';
  }

  if (opener) opener.addEventListener('click', openDrawer);

  form.querySelectorAll('[data-gb-filter-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  if (back) back.addEventListener('click', function () { collapseAll(); });

  /* ── Ebenen ────────────────────────────────────────── */
  groups.forEach(function (g) {
    g.addEventListener('toggle', function () {
      // Immer nur eine Kategorie offen - mobil ist das die zweite Ebene,
      // am Desktop verhindert es überlappende Dropdowns.
      if (g.open) groups.forEach(function (o) { if (o !== g) o.open = false; });
      syncDrill();
    });
  });

  /* ── Absenden ──────────────────────────────────────── */
  // Am Desktop wirkt jede Änderung sofort. In der Schublade wäre das
  // fatal: Sie würde sich beim ersten Häkchen selbst neu laden.
  form.addEventListener('change', function (e) {
    if (isMobile()) return;
    if (e.target.matches('input[type="checkbox"], select, .gb-ftr__price input')) form.submit();
  });

  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('.gb-ftr__price input')) {
      e.preventDefault();
      form.submit();
    }
  });

  /* ── Ausserhalb klicken / Escape ───────────────────── */
  document.addEventListener('click', function (e) {
    if (isMobile() || form.contains(e.target)) return;
    collapseAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (isMobile() && panel && panel.classList.contains('is-open')) {
      // Erst eine Ebene zurück, dann die Schublade schliessen
      if (panel.classList.contains('is-drilled')) collapseAll();
      else closeDrawer();
      return;
    }
    collapseAll();
  });

  // Beim Wechsel der Breite aufräumen, sonst bleibt die Schublade
  // beim Drehen des Geräts im Desktop-Layout hängen.
  mobile.addEventListener('change', function () { closeDrawer(); });
})();
